(() => {
  const GRAMS_PER_LB = 453.592;
  const CART_MUTATION_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  // Product IDs for packaging items whose weight should be hidden from customers
  const HIDDEN_WEIGHT_PRODUCT_IDS = [8337456988248, 8337471144024]; // Gift Box, Cooler/Ice

  let refreshTimer = null;

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    // small delay lets Shopify cart settle after mutation
    refreshTimer = setTimeout(refreshWeight, 120);
  }

  function isCartMutation(url, method = 'GET') {
    const m = String(method).toUpperCase();
    if (!['POST', 'PUT', 'PATCH', 'DELETE'].includes(m)) return false;
    return CART_MUTATION_PATHS.some((p) => String(url || '').includes(p));
  }

  /** Only refresh when line items change, not for note/attributes-only updates */
  function shouldRefreshWeight(url, method, body) {
    if (!isCartMutation(url, method)) return false;

    // cart/add, cart/change, cart/clear always affect line items
    if (
      String(url || '').includes('/cart/add') ||
      String(url || '').includes('/cart/change') ||
      String(url || '').includes('/cart/clear')
    ) {
      return true;
    }

    // cart/update: only refresh if line items changed (has updates), not note/attributes only
    if (String(url || '').includes('/cart/update')) {
      try {
        const parsed = typeof body === 'string' ? JSON.parse(body) : {};
        const hasLineItemUpdates =
          parsed &&
          typeof parsed.updates === 'object' &&
          Object.keys(parsed.updates).length > 0;
        return !!hasLineItemUpdates;
      } catch {
        return false;
      }
    }

    return false;
  }

  async function refreshWeight() {
    // All instances: main header, its noscript/mobile buttons, and the sticky header clone built by section-header.js
	  const els = document.querySelectorAll('.lbs-span');
	  if (!els.length) return;

    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      // Subtract weight of packaging items (gift box, cooler/ice) so customers only see product weight
      const hiddenWeight = (cart.items || [])
        .filter((item) => HIDDEN_WEIGHT_PRODUCT_IDS.includes(item.product_id))
        .reduce((sum, item) => sum + item.grams * item.quantity, 0);
      const lbs = (((cart.total_weight || 0) - hiddenWeight) / GRAMS_PER_LB).toFixed(1);
      els.forEach((el) => {
        el.textContent = `${lbs} lbs`;
      });
    } catch (_) {
      // no-op
    }
  }

  // Initial + passive refreshes
  document.addEventListener('DOMContentLoaded', refreshWeight);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshWeight();
  });
  window.addEventListener('focus', refreshWeight);

  // Fetch interception (Ajax cart updates)
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url =
      typeof input === 'string'
        ? input
        : input && typeof input.url === 'string'
          ? input.url
          : '';
    const method =
      (init && init.method) ||
      (input && typeof input !== 'string' && input.method) ||
      'GET';
    const body = (init && init.body) ?? (input && typeof input !== 'string' && input.body);

    const response = await originalFetch.apply(this, arguments);

    if (response && response.ok && shouldRefreshWeight(url, method, body)) {
      scheduleRefresh();
    }

    return response;
  };

  // XHR interception (some themes/apps still use XHR)
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartMethod = method;
    this._cartUrl = url;
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    this._cartBody = body;
    this.addEventListener('load', () => {
      if (
        this.status >= 200 &&
        this.status < 300 &&
        shouldRefreshWeight(this._cartUrl, this._cartMethod, this._cartBody)
      ) {
        scheduleRefresh();
      }
    });
    return originalSend.apply(this, arguments);
  };
})();